<template>
  <div class="header">
    <div class="main-data">
      <div class="left">
        <div class="title">
          {{ title }}<span class="hint-mess">{{ this.title === '北向资金' ? unit1 : unit2 }}</span>
        </div>
        <div class="name">净买入:</div>
        <div
          :class="{
            up: newHsgtNetBuyData.lgt > 0,
            down: newHsgtNetBuyData.lgt < 0,
            grey: newHsgtNetBuyData.lgt == 0,
            data: true,
          }"
        >
          {{ newHsgtNetBuyData.lgt | formateNewData }}
        </div>
        <div class="date">({{ updateNetBuyDate }})</div>
      </div>
      <div class="right">
        <div class="name">数据日期:</div>
        <div class="time">{{ updateDate }}</div>
        <div class="status">{{ hsgtTradeStatusText }}</div>
      </div>
    </div>
    <div class="detail-data">
      <div class="detail-box">
        <div class="name">
          {{ name1 }}
        </div>
        <div class="data-box">
          <div class="data-line new-data-line">
            <ul class="data-item r-border">
              <li class="data-item-name">净买入</li>
              <li
                :class="{
                  up: newHsgtNetBuyData.hgt > 0,
                  down: newHsgtNetBuyData.hgt < 0,
                  grey: newHsgtNetBuyData.hgt == 0,
                  'big-font': true,
                }"
              >
                {{ newHsgtNetBuyData.hgt | formateNewData }}
              </li>
              <li class="data-item-date">({{ updateNetBuyDate }})</li>
            </ul>
            <ul class="data-item r-border">
              <li class="data-item-name">当日余额</li>
              <li class="data-item-data">
                {{ hsgtQuotaBalanceData.hgt | formateQuotaBalance | formateNewData }}
              </li>
            </ul>
          </div>
        </div>
        <div class="simple-column">
          <simple-column v-if="data.h.up" :up="data.h.up" :equal="data.h.mid" :down="data.h.down" />
        </div>
      </div>
      <div class="detail-box">
        <div class="name">
          {{ name2 }}
        </div>
        <div class="data-box">
          <div class="data-line new-data-line">
            <ul class="data-item r-border">
              <li class="data-item-name">净买入</li>
              <li
                :class="{
                  up: newHsgtNetBuyData.sgt > 0,
                  down: newHsgtNetBuyData.sgt < 0,
                  grey: newHsgtNetBuyData.sgt == 0,
                  'big-font': true,
                }"
              >
                {{ newHsgtNetBuyData.sgt | formateNewData }}
              </li>
              <li class="data-item-date">({{ updateNetBuyDate }})</li>
            </ul>
            <ul class="data-item r-border">
              <li class="data-item-name">当日余额</li>
              <li class="data-item-data">
                {{ hsgtQuotaBalanceData.sgt | formateQuotaBalance | formateNewData }}
              </li>
            </ul>
          </div>
        </div>
        <div class="simple-column">
          <simple-column v-if="data.s.up" :up="data.s.up" :equal="data.s.mid" :down="data.s.down" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import simpleColumn from './simpleColumn';
import { post } from '../../assets/js/request';
import { url, hsgtNetBuyParams, hsgtCode, hsgtQuotaBalanceParams,hsgtTradeStatusMap } from '../../assets/js/config';
import { formateDateByTimestampInSeconds } from '../../common/utils/handleCaptialFlowChartData';
export default {
  props: {
    title: String, // 圆圈内标题
    data: Object,
    canUpdate: Number,
    timestamp: Number, //北向资金数据更新日期，毫秒级时间戳
    hsgtTradeStatus:Number //陆股通交易状态
  },
  data() {
    return {
      name1: '沪股通',
      name2: '深股通',
      unit1: '(人民币)',
      unit2: '(港币)',
      //北向资金净买入数据
      newHsgtNetBuyData: {
        lgt: '--',
        hgt: '--',
        sgt: '--',
      },
      //北向资金数据更新日期
      updateDate: '--',
      //净买入更新日期
      updateNetBuyDate: '--',
      //陆股通交易状态文案
      hsgtTradeStatusText: '--',
      //沪深港通每日额度余额
      hsgtQuotaBalanceData: {
        hgt: '--',
        sgt: '--',
      },
    };
  },
  mounted() {
    this.name1 = this.title === '北向资金' ? '沪股通' : '港股通(沪)';
    this.name2 = this.title === '北向资金' ? '深股通' : '港股通(深)';
    this.getLatestTradeDate(this.timestamp);
    this.getHsgtNetBuyData();
    this.getHsgtQuotaBalanceData();
    this.updateHsgQuotaBalancData();
  },
  components: {
    simpleColumn,
  },
  filters: {
    showNumWithUnit(val, byte = 2) {
      if (isNaN(parseInt(val))) {
        return '--';
      }
      return Number(val).toFixed(byte) + '亿';
    },
    formateNewData(val) {
      if (val || val === 0) {
        const res = F10Utils.formatPcMoney(val);
        return res.value + res.unit;
      }
      return '--';
    },
    formateQuotaBalance(val) {
      if (val === null) {
        return '额度充足';
      }
      return val;
    },
  },
  methods: {
    //获取北向资金净买入数据
    async getHsgtNetBuyData() {
      const params = hsgtNetBuyParams;
      const res = await post(url.indexCommon, params);
      if (res && res.data) {
        const data = res.data.data;
        const timestamp = res.data.indexes[0]['timestamp'];
        this.newHsgtNetBuyData = this.handleData(data, hsgtCode);
        this.updateNetBuyDate = formateDateByTimestampInSeconds(timestamp);
      }
    },

    //获取沪深港通每日额度余额数据
    async getHsgtQuotaBalanceData() {
      const params = hsgtQuotaBalanceParams;
      const res = await post(url.indexCommon, params);
      if (res && res.data) {
        const data = res.data.data;
        this.hsgtQuotaBalanceData = this.handleData(data, hsgtCode);
      }
    },

    //解析接口数据
    handleData(data, obj) {
      const res = {};
      const keys = Object.keys(obj);
      keys.forEach(key => {
        const netBuyData = data.find(item => item.code === obj[key]);
        if (netBuyData) {
          res[key] = netBuyData.values[0]['value'];
        }
      });
      return res;
    },

    //一分钟更新一次陆港通当日余额数据
    updateHsgQuotaBalancData() {
      setInterval(() => {
        if (this.canUpdate) {
          this.getHsgtQuotaBalanceData();
        }
      }, 1000 * 60);
    },

    //获取北向资金最新交易日日期
    getLatestTradeDate(val) {
      if (val || val === 0) {
        this.updateDate = formateDateByTimestampInSeconds(this.timestamp / 1000);
      }
    },
  },
  watch: {
    data: {
      handler(newVal) {
        if (newVal) {
          this.hsgtNetBuyData = newVal;
        }
      },
      deep: true,
      immediate: true,
    },
    timestamp(val) {
      this.getLatestTradeDate(val);
    },
    hsgtTradeStatus() {
      this.hsgtTradeStatusText = hsgtTradeStatusMap[this.hsgtTradeStatus] || '--';
    },
  },
};
</script>
<style lang="less">
@import './index.less';
</style>
